import React, { useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import { withTranslation } from 'react-i18next'

import ActiveProTracks from 'app/domains/routes/Profile/ActiveProTracks'
import OutOfOffice from './OutOfOfficeBlock'
import Button from 'app/components/ButtonDefault'

import './styles.scss'

const bc = 'settings-dashboard'
const id = bc

const SettingsDashboard = ({ t, setComponentsHeight }) => {
  useEffect(() => {
    setComponentsHeight(id)
  }, [])
  return (
    <div className={bc} id={id}>
      <h2 className={`${bc}__title`}>{t('Out of office')}</h2>
      <OutOfOffice isShowSubmitButton />
      <div className={`${bc}__line`} />
      <h2 className={`${bc}__title`}>{t('Switch ProTrack')}</h2>
      <ActiveProTracks />
      <div className={`${bc}__line`} />
      <NavLink to="/profile">
        <Button outline>{t('Go to all settings')}</Button>
      </NavLink>
    </div>
  )
}

export default withTranslation('user')(SettingsDashboard)
